<template>
    <div
        class="p-6 bg-slate-300/30 rounded-2xl shadow-inner border-solid border-b border-t-0 border-x-0 border-white flex-col gap-4 flex"
    >
        <div>
            <div class="font-bold text-xs text-slate-700 mb-2" data-test="sidebar-filter-label">Team</div>
            <vx-selectable
                v-model="filters.team_id"
                placeholder="-"
                :reduce="(option) => option.value"
                :loading="loadingTeams"
                :options="teams"
                @search="searchTeams"
                :clearable="false"
                data-test="teams-selectable"
            >
            </vx-selectable>
        </div>
        <kiosk-radio-filter
            label="Billable"
            name="billable"
            :options="billableOptions"
            v-model="filters.is_billable"
        ></kiosk-radio-filter>
        <kiosk-radio-filter
            label="Favorite"
            name="favorite"
            :options="favoriteOptions"
            v-model="filters.is_favorite"
        ></kiosk-radio-filter>
    </div>
</template>

<script setup>
import { VxSelectable } from '@voxie/frontend-components';
import KioskRadioFilter from '~/components/kiosk/KioskRadioFilter.vue';
import { ref } from 'vue';
import { useToasted } from '~/composables/useToasted';
import { adminTeamsClient } from '~/services';
import debounce from '~/utils/debounce';

const toasted = useToasted();

const favoriteOptions = [
    { label: 'All', value: undefined },
    { label: 'Yes', value: '1' },
    { label: 'No', value: '0' },
];

const billableOptions = [
    { label: 'All', value: undefined },
    { label: 'Yes', value: '1' },
    { label: 'No', value: '0' },
];

const filters = defineModel({
    default: () => ({}),
});

const teams = ref([]);
const loadingTeams = ref();

const searchTeams = debounce((query) => {
    loadingTeams.value = true;

    adminTeamsClient
        .getTeams({
            query: query,
            per_page: 100,
            has_feature: 'contact_groups',
        })
        .then((response) => {
            teams.value = response.data.data.map((team) => ({
                value: team.id,
                label: `${team.id} - ${team.name}`.trim(),
            }));
        })
        .catch((e) => {
            console.error(e);
            toasted.global.platform_error();
        })
        .finally(() => {
            loadingTeams.value = false;
        });
}, 300);

searchTeams();
</script>
